/**
 * Debug utility for Venty - All logging disabled
 * All functions are now silent (no-ops) for production use
 */

// Debug utility - production mode (silent logging)
export const debugLog = (...args) => {
  // Silent - no logging in production
};

export const debugWarn = (...args) => {
  // Silent - no logging in production
};

export const debugError = (...args) => {
  // Silent - no logging in production
};

export const debugInfo = (...args) => {
  // Silent - no logging in production
};

// Always log errors in production (for monitoring)
export const errorLog = (...args) => {
  console.error(...args);
};

// Always log warnings in production (for monitoring)
export const warnLog = (...args) => {
  console.warn(...args);
};